"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemIcons = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _components = require("./components");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  ref: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
    current: (0, _propTypes.instanceOf)(Element)
  })]),
  children: _propTypes.node,
  color: _propTypes.string,
  fontSize: (0, _propTypes.oneOf)(['default', 'large', 'small']),
  viewBox: _propTypes.string,
  titleAccess: _propTypes.string
} : {};
const defaultProps = {
  component: 'svg',
  color: 'neutral04',
  fontSize: 'default',
  viewBox: '0 0 48 48'
};

const SystemIcons = ({
  'data-testid': testId,
  component,
  className,
  children,
  viewBox,
  color,
  titleAccess,
  ref,
  ...other
}) => (0, _core.jsx)(_components.SystemIcons, (0, _extends2.default)({
  as: component,
  className: className,
  "data-testid": testId,
  focusable: "false",
  viewBox: viewBox,
  color: color,
  "aria-hidden": titleAccess ? undefined : 'true',
  role: titleAccess ? 'img' : 'presentation',
  ref: ref
}, other), children, titleAccess ? (0, _core.jsx)("title", null, titleAccess) : null);

SystemIcons.defaultProps = defaultProps;
process.env.NODE_ENV !== "production" ? SystemIcons.propTypes = propTypes : void 0;
const WithForwardRef = (0, _utils.withForwardRef)(SystemIcons);
exports.SystemIcons = WithForwardRef;